/*
 * Retrieves the options for the search filters from the API. This uses Axios rather than Feathers,
 * and as the API endpoints have changed it is now driven from an explicit endpoint property for each filter.
 */
import useAxios from "./useAxios";

export interface OptionType {
    label: string;
    value: string;
}

const useFilterOptions = (url: string, endpoint: string, queryParams?: any): OptionType[] => {   
    const [data, loading] = useAxios<string[]>(`${url}/${endpoint}`, queryParams, 60000);

    return loading ? [] : Array.isArray(data) ? data.map(d => ({ label: d, value: d })) : [];
};

export default useFilterOptions;
